import {useEffect, useRef, useState} from "react";
import "firebase/app";
import CsvDownloader from "react-csv-downloader";
import {collection, doc, getDoc, getDocs, limit, orderBy, query, startAfter, where,} from "firebase/firestore";
import {Button, Card, Col, Container, Row, Tooltip} from "reactstrap";
import DataTable from "react-data-table-component";
import Multiselect from "multiselect-react-dropdown";
import moment from "moment";
import numeral from "numeral";
import {
    firebaseConstants,
    getAchievementBadge,
    getDb,
    getPositionBadge,
    multiselectDropdownStyle,
    myAdmin,
} from "../../util/Constants";
import {useParams} from "react-router-dom";
import _ from "lodash";
import {cities} from "../../util/Cities";

let timer = null;

const Leaderboard = (props) => {
    const [userCount, setUserCount] = useState(0);
    const [activeUserCount, setActiveUserCount] = useState(0);
    const [leaderboard, setLeaderboard] = useState([]);
    const [activeLeaderboard, setActiveLeaderboard] = useState([]);
    const [leaderboardToExport, setLeaderboardToExport] = useState([]);
    const [funFacts, setFunFacts] = useState([]);
    const [levelsData, setLevelsData] = useState([]);
    const [departmentsData, setDepartmentsData] = useState([]);
    const [regionsData, setRegionsData] = useState([]);
    const [level, setLevel] = useState(null);
    const [department, setDepartment] = useState(null);
    const [regions, setRegions] = useState([]);
    const [cgpaSearchData, setCgpaSearchData] = useState([]);
    const [degreeSearchData, setDegreeSearchData] = useState([]);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [loadingLeaderboard, setLoadingLeaderboard] = useState(true);
    const [loadingFunFacts, setLoadingFunFacts] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [lastVisible, setLastVisible] = useState(null);
    const [nameSearchData, setNameSearchData] = useState([]);
    const [emailSearchData, setEmailSearchData] = useState([]);
    const [loadingSearchData, setLoadingSearchData] = useState(false);
    const [tooltipOpen, setTooltipOpen] = useState(null);
    const [assessment, setAssessment] = useState(null);
    const [registrationFeilds, setRegistrationFeilds] = useState([]);
    const [projectType, setProjectType] = useState("");
    const [clearFiltersData, setClearFiltersData] = useState(false);
    const [filters, setFilters] = useState([]);
    const [selectedCgpa, setSelectedCgpa] = useState(null);
    const [selectedCity, setSelectedCity] = useState([]);
    const [selectedInstitute, setSelectedInstitute] = useState(null);

    const searchByNameDropdown = useRef();
    const searchByEmailDropdown = useRef();
    const searchByCgpa = useRef();
    const searchByCity = useRef();
    const searchByInstitute = useRef();
    const searchByDegree = useRef();
    const levelDropdown = useRef();
    const departmentDropdown = useRef();
    const regionDropdown = useRef();
    const { eventId } = useParams();
    const db = getDb();
    const usersRef = collection(db, firebaseConstants.dbUsers);
    const utilRef = collection(db, firebaseConstants.dbUtil);
    const regionRef = collection(db, firebaseConstants.dbRegions);
    const departmentRef = collection(db, firebaseConstants.dbDepartments);

    let totalPages = 1;
    const pagesSeen = [];

    useEffect(() => {
        console.log(leaderboard, "leaderboard in useEffect");
        console.log(activeLeaderboard, "activeLeaderboard in use effect");
    }, [leaderboard, activeLeaderboard]);

    useEffect(() => {
        // getLevel().then(data => {
        //     console.log(data)
        // })

        getMetaData().then((data) => {
            setAssessment(data.assessment);
            // set
            // setLevelsData(data.levels);
        });

        getEventData().then((data) => {
            if (data) {
                setRegistrationFeilds(data?.registrationFields);
                setFilters(data?.filters);
                setProjectType(data?.projectType);
                setDepartmentsData(data?.departments);
                setRegionsData(data.region);
            }
        });
        getAnalytics().then((data) => {
            setUserCount(data);
            setActiveUserCount(data);
        });
        getFunFacts().then((data) => {
            console.log(data,)
            setFunFacts(data);
            setLoadingFunFacts(false);
        });
        // exportToCSV().then(data => {
        //     setLeaderboardToExport(data);
        // });
        // fetchDepartments();
        // fetchRegions();
        console.log(myAdmin);
    }, []);

    const getEventData = async () => {
        const docRef = doc(db, "Events", eventId);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
            return docSnap.data();
        }
    };

    //changes by me
    // const fetchDepartments = async () => {
    //     const querySnapshot = await getDocs(departmentRef);
    //     let dataArr = []
    //     querySnapshot.forEach((doc) => {
    //         dataArr.push(
    //             {
    //                 department: doc.data().department,
    //             }
    //         )
    //     });
    //     setDepartmentsData(dataArr.map((e) => e.department));
    // }

    // const fetchRegions = async () => {
    //     const querySnapshot = await getDocs(regionRef);
    //     let dataArr = []
    //     querySnapshot.forEach((doc) => {
    //         dataArr.push(
    //             {
    //                 region: doc.data().region,
    //             }
    //         )
    //     })
    //     setRegionsData(dataArr.map((e) => e.region));
    // }

    useEffect(async () => {
        const selectedName = searchByNameDropdown.current.getSelectedItems();
        const selectedEmail = searchByEmailDropdown.current.getSelectedItems();
        let selectedCgpa = "";
        let selectedDegree = "";
        if (registrationFeilds.includes("cgpa")) {
            selectedCgpa = searchByCgpa.current.getSelectedItems();
        }
        if (registrationFeilds.includes("degree")) {
            selectedDegree = searchByDegree.current.getSelectedItems();
        }
        if (
            selectedName.length === 0 &&
            selectedEmail.length === 0 &&
            selectedCgpa.length === 0 &&
            selectedDegree.length === 0
        ) {
            if (leaderboard.length < rowsPerPage * currentPage - rowsPerPage + 1) {
                await getLeaderboard(true, false);
            } else {
                setActiveLeaderboard(
                    leaderboard.slice(
                        currentPage * rowsPerPage - rowsPerPage,
                        currentPage * rowsPerPage
                    )
                );
            }
        }
        console.log(currentPage);
    }, [currentPage, rowsPerPage, clearFiltersData]);

    const getMetaData = async () => {
        let dept = [],
            levels = [],
            regions = [];
        const docRef = doc(utilRef, "meta");
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
            const data = docSnap.data();
            dept = data.departments ? data.departments : [];
            levels = data.levels ? data.levels : [];
            regions = data.regions ? data.regions : [];
        }
        return { departments: dept, levels: levels, regions: regions };
    };

    // const getLevel = async () => {
    //   if (props.signedInUser) {
    //     if (props.sheetsLoaded) {
    //       const sheetData = await getLevels();
    //       setLevelsData(sheetData.map((e) => e["Tab Name"]));
    //     }
    //   }
    // };

    // useEffect(() => {
    //   getLevel().then(() => {});
    // }, [props.signedInUser, props.sheetsLoaded]);

    const getAnalytics = async () => {
        if (userCount) {
            return userCount;
        } else {
            let count = 0;
            const docRef = doc(usersRef, "analytics");
            const docSnap = await getDoc(docRef);
            if (docSnap.exists()) {
                const data = docSnap.data();
                count = data[eventId];
            }

            return count;
        }
    };

    const getLeaderboard = async (
        useLastVisible = true,
        useConstraints = true
    ) => {
        let data = [];
        let constraints = useConstraints ? getConstraints() : []
        let order = getOrder(useConstraints);
        let limits = [];
        let q = null;
        console.log(constraints, "All constrtaints");
        if (constraints.length === 0) {
            limits.push(limit(rowsPerPage));
        }

        if (useLastVisible && lastVisible) {
            q = query(
                usersRef,
                where("eventId", "==", eventId),
                ...constraints,
                ...order,
                startAfter(lastVisible),
                ...limits
            );
        } else {
            q = query(
                usersRef,
                where("eventId", "==", eventId),
                ...constraints,
                ...order,
                ...limits
            );
        }
        const querySnapshot = await getDocs(q);
        setLastVisible(querySnapshot.docs[querySnapshot.docs.length - 1]);
        let startRank = 1;
        if (constraints.length > 0) {
            startRank = 1;
        } else {
            startRank = currentPage * rowsPerPage - rowsPerPage + 1;
        }

        querySnapshot.docs.forEach((doc, index) => {
            data.push({ id: doc.id, ...doc.data() });
            // startRank++;
        });

        data = _.orderBy(data, ["currentScore"], ["desc"]);

        data = data.map((doc, index) => {
            doc = { rank: startRank, ...doc };
            startRank++;
            return doc;
        });
        console.log(data, "Getting this data");
        if (useConstraints) {
            setLeaderboard(data);
            setActiveLeaderboard(
                data.slice(
                    currentPage * rowsPerPage - rowsPerPage,
                    currentPage * rowsPerPage
                )
            );
            setActiveUserCount(data.length);
        } else {
            const count = await getAnalytics();
            setActiveUserCount(count);
            setLeaderboard([...leaderboard, ...data]);
            setActiveLeaderboard(data);
        }

        setNameSearchData(
            data.map((_data) => ({
                value: (
                    <span>
                        {_data.name} - <span className="">{_data.email}</span>
                    </span>
                ),
                rank: 1,
                id: _data.id,
                ..._data,
            }))
        );

        setEmailSearchData(
            data.map((_data) => ({
                value: (
                    <span>
                        {_data.name} - <span className="">{_data.email}</span>
                    </span>
                ),
                rank: 1,
                id: _data.id,
                ..._data,
            }))
        );

        setCgpaSearchData([{ value: "1-2" }, { value: "2-3" }, { value: "3-4" }]);
        //degree

        const UniqueDegrees = data
            .map((_data) => ({
                value: (
                    <span>
                        <span className="">{_data.userInfo?.degree}</span>
                    </span>
                ),
                rank: 1,
                id: _data.id,
                ..._data,
            }))
            .filter(
                (obj, index, self) =>
                    index ===
                    self.findIndex((t) => t.userInfo?.degree === obj.userInfo?.degree)
            )
            .filter((e) => e.userInfo);

        setDegreeSearchData(UniqueDegrees);

        setLoadingLeaderboard(false);
    };

    const getFunFacts = async () => {
        const q = query(
            usersRef,
            where("eventId", "==", eventId),
            orderBy("achievementCount", "desc"),
            limit(5)
        ),
            data = [];
        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
            if (!_.isEmpty(doc?.data().capabilities)) {
                data.push({ id: doc.id, ...doc.data() });
            }
        });
        console.log(data,"data fun fact");

        return data;
    };

    const applyFilters = () => {
        setLoadingLeaderboard(true);
        setLastVisible(null);
        setLeaderboard([]);
        setActiveLeaderboard([]);
        setActiveUserCount(0);

        searchByNameDropdown.current.resetSelectedValues();
        searchByEmailDropdown.current.resetSelectedValues();

        // if(!checkProjectType){
        //     searchByCgpa.current.resetSelectedValues();
        //     searchByDegree.current.resetSelectedValues();
        // }

        getLeaderboard(false, true).then((r) => {
        });
    };

    const clearFilters = () => {
        console.log(currentPage, "11");
        setLevel(null);
        setDepartment(null);
        setRegions([]);
        setStartDate(null);
        setEndDate(null);
        setLoadingLeaderboard(true);
        setLastVisible(null);
        setLeaderboard([]);
        setActiveLeaderboard([]);
        setActiveUserCount(1);
        setClearFiltersData(!clearFiltersData);
        setCurrentPage(1);
        setSelectedCity([]);
        setSelectedInstitute([]);
        setSelectedCgpa(null);
        // setActiveUserCount(userCount);

        searchByNameDropdown.current.resetSelectedValues();
        searchByEmailDropdown.current.resetSelectedValues();
        searchByCity.current.resetSelectedValues();
        searchByCgpa.current.resetSelectedValues();
        // levelDropdown.current.resetSelectedValues();
        registrationFeilds.includes("department") &&
            departmentDropdown.current.resetSelectedValues();
        registrationFeilds.includes("region") &&
            regionDropdown.current.resetSelectedValues();

        // getLeaderboard(false, false).then((r) => {});
    };

    const getConstraints = () => {
        const constraints = [];
        if (level) {
            constraints.push(where("currentLevel", "==", Number(level)));
        }
        if (department) {
            constraints.push(where("department", "==", department));
        }
        if (regions.length > 0) {
            constraints.push(where("region", "in", regions));
        }
        if (selectedCity.length > 0) {
            console.log(selectedCity, "selectedCity");
            constraints.push(where("userInfo.city", "in", selectedCity));
        }
        if (selectedCgpa) {
            console.log(selectedCgpa, "selectedCgpa");
            const [value1, value2] = selectedCgpa.split('-').map(Number);
            constraints.push(
                where("userInfo.cgpa", ">=", value1),
                where("userInfo.cgpa", "<=", value2)
            );
        }
        if (startDate) {
            constraints.push(where("lastUpdated", ">", startDate.valueOf()));
        }
        if (endDate) {
            constraints.push(where("lastUpdated", "<", endDate.valueOf()));
        }
        return constraints;
    };

    const getOrder = (useConstraints = true) => {
        if (useConstraints) {
            const order = [];
            if (selectedCgpa) {
                order.push(orderBy("userInfo.cgpa"));
            }
            if (startDate || endDate) {
                order.push(orderBy("lastUpdated"));
            }
            order.push(orderBy("currentScore", "desc"));
            return order;
        } else {
            return [orderBy("currentScore", "desc")];
        }
    };

    const handleSearch = async (searchText, searchBy) => {
        const constraints = getConstraints();
        let userData = [];
        let q;
        if (constraints.length > 0) {
            // constraints applied

            const unsortedData = leaderboard
                .filter((user) =>
                    user[searchBy].toLowerCase().includes(searchText.toLowerCase())
                )
                .slice(0, 10)
                .map((user) => ({
                    ...user,
                    value: (
                        <span>
                            {user.name} - <span className="">{user.email}</span>
                        </span>
                    ),
                }));
            userData = _.orderBy(unsortedData, [searchBy], ["desc"]);
        } else {
            if (searchBy === "degree") {
                q = query(
                    usersRef,
                    where(`userInfo.degree_insensitive`, ">=", searchText.toLowerCase()),
                    where("eventId", "==", eventId),
                    orderBy(`userInfo.degree_insensitive`),
                    limit(10)
                );
            } else {
                q = query(
                    usersRef,
                    where(`${searchBy}_insensitive`, ">=", searchText.toLowerCase()),
                    where("eventId", "==", eventId),
                    orderBy(`${searchBy}_insensitive`),
                    limit(10)
                );
            }

            const querySnapshot = await getDocs(q);
            querySnapshot.docs.forEach((doc) => {
                const data = doc.data();
                userData.push(
                    searchBy !== "degree"
                        ? {
                            value: (
                                <span>
                                    {data.name} - <span className="">{data.email}</span>
                                </span>
                            ),
                            id: doc.id,
                            ...data,
                        }
                        : {
                            value: <span>{data.userInfo.degree}</span>,
                            id: doc.id,
                            ...data,
                        }
                );
            });
        }

        if (searchBy === "degree") {
            userData = userData.filter((_data) =>
                _data.userInfo.degree_insensitive.startsWith(searchText.toLowerCase())
            );
            setDegreeSearchData(userData);
        } else {
            userData = userData.filter((_data) =>
                _data[`${searchBy}_insensitive`].startsWith(searchText.toLowerCase())
            );
            searchBy === "name"
                ? setNameSearchData(userData)
                : setEmailSearchData(userData);
        }
        setLoadingSearchData(false);
    };

    const removeSearch = (list, item) => {
        console.log(item, list, "removing items");
        // if (getConstraints().length > 0) {
        setActiveLeaderboard(
            leaderboard.slice(
                currentPage * rowsPerPage - rowsPerPage,
                currentPage * rowsPerPage
            )
        );
        // setActiveUserCount(leaderboard.length);
        // } else {
        // setActiveLeaderboard(
        //   leaderboard
        // );
        setActiveUserCount(userCount);
        // }
    };

    // const exportToCSV = async () => {
    //     let data = [],
    //         constraints = getConstraints(),
    //         order = getOrder(false);
    //     console.log(constraints.length, "Constraints length");
    //     if (constraints.length === 0) {
    //         // get all data from DB
    //         const q = query(usersRef, where("eventId", "==", eventId), ...order);
    //         const querySnapshot = await getDocs(q);
    //
    //         querySnapshot.docs.forEach((doc, index) => {
    //             const userData = doc.data();
    //             data.push({
    //                 ...userData,
    //                 rank: index + 1,
    //                 id: doc.id,
    //                 lastUpdated: moment(userData.lastUpdated).format("DD/MMM/YY HH:mm"),
    //             });
    //         });
    //
    //         data.push({
    //             ...data,
    //             filters: `Level: ${level}, Department:${department}, Region:${regions},Range:${moment(
    //                 startDate
    //             ).format("MM/DD/YYYY")}-${moment(endDate).format("MM/DD/YYYY")}`,
    //         });
    //     } else {
    //         // data is already fetched
    //         data = leaderboard.map((_user) => ({
    //             ..._user,
    //             lastUpdated: moment(_user.lastUpdated).format("DD/MMM/YY HH:mm"),
    //         }));
    //         data.push({
    //             ...data,
    //             filters: `Level: ${level}, Department:${department}, Region:${regions},Range:${moment(
    //                 startDate
    //             ).format("MM/DD/YYYY")}-${moment(endDate).format("MM/DD/YYYY")}`,
    //         });
    //     }
    //     console.log(data, "Data goin to be in csv");
    //     return data;
    // };
    const exportToCSV = async () => {
        let data = [],
            constraints = getConstraints(),
            order = getOrder(false);
        console.log(constraints.length, "Constraints length");
        if (constraints.length === 0) {
            try {
                // get all data from DB
                const q = query(usersRef, where("eventId", "==", eventId), ...order);
                const querySnapshot = await getDocs(q);
                console.log(querySnapshot.docs.length);
                querySnapshot.docs.forEach((doc, index) => {
                    const userData = doc.data();
                    const userInfo = userData?.userInfo;
                    const mainObject = {...userData, ...userInfo, email: userData.email };
                    const fields = ["lastUpdated", "dob", "createdAt"];
                    for (const key in mainObject) {
                        // if (typeof mainObject[key] === 'string' && /[,()]/.test(mainObject[key])) {
                        if (!fields.includes(key)) {
                            mainObject[key] = `"${mainObject[key]}"`;
                        }
                    }
                    const dobTimestamp = mainObject?.dob;
                    const dobDate = dobTimestamp && dobTimestamp.seconds ? dobTimestamp.toDate() : null; // Convert Firestore Timestamp to JavaScript Date
                    const formattedDob = dobDate ? moment(dobDate).format("DD/MMM/YYYY") : ''; // Format date, or set to empty string if dobDate is null

                    let formattedcreatedAt = "";
                    if (mainObject?.createdAt) {
                        const createdAtTimestamp = mainObject?.createdAt;
                        formattedcreatedAt = moment.unix(createdAtTimestamp).format("DD/MMM/YYYY");
                    }

                    data.push({
                        ...mainObject,
                        // ...userInfo,
                        // ...userData,
                        rank: index + 1,
                        id: doc.id,
                        lastUpdated: moment(userData.lastUpdated).format("DD/MMM/YY HH:mm"),
                        userCreated: moment(userData.userCreated).format("DD/MMM/YY HH:mm"),
                        dob: formattedDob,
                        createdAt: formattedcreatedAt
                    });
                });

                // data.push({
                //     ...data,
                //     filters: `Level: ${level}, Department:${department}, Region:${regions},Range:${moment(
                //         startDate
                //     ).format("MM/DD/YYYY")}-${moment(endDate).format("MM/DD/YYYY")}`,
                // });
            } catch (e) {
                console.log(e)
            }
        } else {
            // data is already fetched
            data = leaderboard.map((_user) => {
                const userInfoValues = Object.values(_user.userInfo);
                const mainObject = {..._user.userInfo, ..._user, email: _user.email};
                for (const key in mainObject) {
                    if (typeof mainObject[key] === 'string' && mainObject[key].includes(",")) {
                        mainObject[key] = `"${mainObject[key]}"`;
                    }
                }
                const dobTimestamp = _user.userInfo.dob;
                const dobDate = dobTimestamp && dobTimestamp.seconds ? dobTimestamp.toDate() : null; // Convert Firestore Timestamp to JavaScript Date
                const formattedDob = dobDate ? moment(dobDate).format("DD/MMM/YYYY") : ''; // Format date, or set to empty string if dobDate is null
                let formattedcreatedAt = "";
                if (mainObject?.createdAt) {
                    const createdAtTimestamp = mainObject?.createdAt;
                    formattedcreatedAt = moment.unix(createdAtTimestamp).format("DD/MMM/YYYY");
                }
                return {
                    ...mainObject,
                    lastUpdated: moment(_user.lastUpdated).format("DD/MMM/YY HH:mm"),
                    userCreated: moment(_user.userCreated).format("DD/MMM/YY HH:mm"),
                    dob: formattedDob,
                    createdAt: formattedcreatedAt
                };
            });
            // data.push({
            //     ...data,
            //     filters: `Level: ${level}, Department:${department}, Region:${regions},Range:${moment(
            //         startDate
            //     ).format("MM/DD/YYYY")}-${moment(endDate).format("MM/DD/YYYY")}`,
            // });
        }
        console.log(data, "Data goin to be in csv");
        return data;
    };
    const onSelectCgpa = async (item) => {
        let originalString = item.value;
        const hyphenIndex = originalString.indexOf("-");
        const value1 = originalString.substr(hyphenIndex - 1, 1);
        const value2 = originalString.substr(hyphenIndex + 1, 1);
        let userData = [];

        try {
            const populationQuery = query(
                usersRef,
                where("userInfo.cgpa", ">=", Number(value1)),
                where("userInfo.cgpa", "<=", Number(value2)),
                where("eventId", "==", eventId),
                limit(10)
            );
            const querySnapshot = await getDocs(populationQuery);

            querySnapshot.docs.forEach((doc) => {
                const data = doc.data();
                userData.push({
                    value: (
                        <span>
                            {`${data.name} - `}
                            <span className="user-id">{doc.id}</span>
                        </span>
                    ),
                    id: doc.id,
                    ...data,
                });
            });
            setActiveLeaderboard(userData);
            setActiveUserCount(userData.length);
            // setUserCount(userData.length)
        } catch (error) {
            console.error(error);
        }
        searchByNameDropdown.current.resetSelectedValues();
        searchByEmailDropdown.current.resetSelectedValues();
        searchByDegree?.current?.resetSelectedValues();
    };
    const onSelectCity = async (item) => {
        // console.log(item);
        let selectedCities = searchByCity.current.getSelectedItems();
        selectedCities = selectedCities.map(item => item.value);
        console.log(selectedCities, "Function call");
        let userData = [];
        try {
            const populationQuery = query(
                usersRef,
                where("userInfo.city", "in", selectedCities),
                where("eventId", "==", eventId),
                // limit(10)
            );
            const querySnapshot = await getDocs(populationQuery);
            console.log(querySnapshot.docs.length);
            querySnapshot.docs.forEach(doc => {
                const data = doc.data();
                console.log(data);
                userData.push(data);
            });
            setActiveLeaderboard(userData);
            setActiveUserCount(userData.length);
        } catch (e) {
            console.log(e);
        }
    }
    const onSelectDegree = async (item) => {
        let str = item.userInfo.degree;

        let userData = [];

        try {
            const populationQuery = query(
                usersRef,
                where("userInfo.degree", "==", str),
                where("eventId", "==", eventId),
                limit(10)
            );
            const querySnapshot = await getDocs(populationQuery);

            querySnapshot.docs.forEach((doc) => {
                const data = doc.data();
                userData.push({
                    value: (
                        <span>
                            {`${data.name} - `}
                            <span className="user-id">{doc.id}</span>
                        </span>
                    ),
                    id: doc.id,
                    ...data,
                });
            });
            setActiveLeaderboard(userData);
            setActiveUserCount(userData.length);
            // setUserCount(userData.length)
        } catch (error) {
            console.error(error);
        }

        searchByNameDropdown.current.resetSelectedValues();
        searchByEmailDropdown.current.resetSelectedValues();
        searchByCgpa?.current?.resetSelectedValues();
    };
    const checkProjectType = () => {
        return projectType === "progress";
    };

    // const getDynamicColumnsForCsv = (leaderboard) => {
    //     console.log(leaderboard, "leaderboard downloading");
    //     const fieldsToEliminate = ["levelScores", "achievements", "levels", "capabilities", "userInfo"];
    //     if (leaderboard.length > 0) {
    //         return Object.keys(leaderboard[0]).filter(key => !fieldsToEliminate.includes(key));
    //     }
    // }

    const getDynamicColumnsForCsv = (leaderboard) => {
        if (leaderboard.length > 0) {
            const maxUserInfoIndex = leaderboard.reduce((maxIndex, item, index, arr) => {
                // if (Object.hasOwnProperty("userInfo")) {
                const currentKeysCount = Object.keys(item?.userInfo || []).length;
                const maxKeysCount = Object.keys(arr[maxIndex]?.userInfo || []).length;
                return currentKeysCount > maxKeysCount ? index : maxIndex;
                // }
            }, 0);
            const userInfoKeys = Object.keys(leaderboard[maxUserInfoIndex]?.userInfo || []);
            const fieldsToEliminate = ["levelScores", "shortlisted", "achievements", "levels", "capabilities", "userInfo", "degree_insensitive", "id", "avatar", "createdAt", "expiryDate", "canExpire", "eventId", "avatarselected", "isActive", "achievementCount", "oncelogin", "name_insensitive", "email_insensitive", "lastCompletedScore", "homeTown", "currentAddress", "department", "region"];
            return [...Object.keys(leaderboard[maxUserInfoIndex]).filter(key => !fieldsToEliminate.includes(key)), ...userInfoKeys.filter(key => !fieldsToEliminate.includes(key))];
        }
    }


    return (
        <>
            {/* <div className="header  pb-8 pt-5 pt-md-8" /> */}
            <Container className="" fluid>
                <h1 className="mb-0 custom-font letterSpacing">Filters</h1>
                <div className="mb-4">
                    {filters && filters?.length > 0 && (
                        <Row>
                            {filters.includes("department") && (
                                <Col md={2}>
                                    {/* <h5 className="text-muted">Department</h5> */}
                                    <Multiselect
                                        ref={departmentDropdown}
                                        className="form-control-alternative mb-1 filters-sub"
                                        isObject={false}
                                        showArrow={true}
                                        selectionLimit={1}
                                        placeholder="Department"
                                        options={departmentsData}
                                        closeIcon="cancel"
                                        onSelect={(list, item) => setDepartment(item)}
                                        onRemove={(list, item) => setDepartment(null)}
                                        style={multiselectDropdownStyle}
                                    />
                                    <p className="mb-0 small text-muted float-right">
                                        Single Select
                                    </p>
                                </Col>
                            )}
                            {filters.includes("region") && (
                                <Col md={2}>
                                    {/* <h5 className="text-muted">Region</h5> */}
                                    <Multiselect
                                        ref={regionDropdown}
                                        className="form-control-alternative mb-1 filters-sub"
                                        isObject={false}
                                        showArrow={true}
                                        placeholder="Region"
                                        options={regionsData}
                                        closeIcon="cancel"
                                        onSelect={(list, item) => setRegions([...regions, item])}
                                        onRemove={(list, item) =>
                                            setRegions(regions.filter((i) => i !== item))
                                        }
                                        style={multiselectDropdownStyle}
                                    />
                                    <p className="mb-0 small text-muted float-right">
                                        Multi Select
                                    </p>
                                </Col>
                            )}
                            {filters.includes("cgpa") &&
                                <Col md={2}>
                                    <Multiselect
                                        className="form-control-alternative filters-sub"
                                        ref={searchByCgpa}
                                        selectionLimit={1}
                                        // showArrow={true}
                                        hidePlaceholder={true}
                                        displayValue="value"
                                        placeholder="Search by CGPA"
                                        options={cgpaSearchData}
                                        closeIcon="cancel"
                                        loading={loadingSearchData}
                                        onSelect={(list, item) => setSelectedCgpa(item.value)}
                                        onRemove={removeSearch}
                                        // disableSearch={true} // set disableSearch prop to true
                                        hideSearch={true}
                                        style={multiselectDropdownStyle}
                                    />
                                </Col>
                            }
                            {filters.includes("city") &&
                                <Col md={2}>
                                    <Multiselect
                                        className="form-control-alternative filters-sub"
                                        ref={searchByCity}
                                        // showArrow={true}
                                        hidePlaceholder={true}
                                        displayValue="value"
                                        placeholder="Search by City"
                                        options={cities}
                                        showArrow={true}
                                        closeIcon="cancel"
                                        loading={loadingSearchData}
                                        onSelect={(list, item) => setSelectedCity([...selectedCity, item.value])}
                                        onRemove={removeSearch}
                                        // disableSearch={true} // set disableSearch prop to true
                                        hideSearch={true}
                                        style={multiselectDropdownStyle}
                                    />
                                </Col>
                            }

                            {/*{filters.includes("department") ||*/}
                            {/*filters.includes("region") ? (*/}
                            {filters.length > 0 && (
                                <Col md={3}>
                                    <Button color="primary" onClick={applyFilters}>
                                        Apply
                                    </Button>
                                    <Button color="danger" onClick={clearFilters}>
                                        Clear
                                    </Button>
                                </Col>
                            )}
                            {/*) : null}*/}
                        </Row>
                    )}
                    <Row className="filters-bg d-flex ">
                        <Col md={5}>
                            <Multiselect
                                className="form-control-alternative filters-sub"
                                ref={searchByNameDropdown}
                                // showArrow={true}
                                hidePlaceholder={true}
                                displayValue="value"
                                selectionLimit={1}
                                placeholder="Search by Name"
                                options={nameSearchData}
                                closeIcon="cancel"
                                loading={loadingSearchData}
                                onSelect={(list, item) => {
                                    searchByEmailDropdown.current?.resetSelectedValues();
                                    searchByDegree?.current?.resetSelectedValues();
                                    searchByCgpa?.current?.resetSelectedValues();
                                    console.log(item);
                                    setActiveLeaderboard([item]);
                                    setActiveUserCount(1);
                                }}
                                onRemove={removeSearch}
                                onSearch={(text) => {
                                    // setNameSearchData([]);
                                    clearTimeout(timer);
                                    if (text.length >= 1) {
                                        setLoadingSearchData(true);
                                        timer = setTimeout(() => {
                                            handleSearch(text, "name").then((r) => {
                                            });
                                        }, 1000);
                                    } else {
                                        setLoadingSearchData(false);
                                    }
                                }}
                                style={multiselectDropdownStyle}
                            />
                        </Col>
                        <Col md={5}>
                            <Multiselect
                                className="form-control-alternative filters-sub"
                                ref={searchByEmailDropdown}
                                // showArrow={true}
                                hidePlaceholder={true}
                                displayValue="value"
                                selectionLimit={1}
                                placeholder="Search by Email"
                                options={emailSearchData}
                                closeIcon="cancel"
                                loading={loadingSearchData}
                                onSelect={(list, item) => {
                                    searchByNameDropdown.current.resetSelectedValues();
                                    searchByDegree?.current?.resetSelectedValues();
                                    searchByCgpa?.current?.resetSelectedValues();
                                    setActiveLeaderboard([item]);
                                    setActiveUserCount(1);
                                }}
                                onRemove={removeSearch}
                                onSearch={(text) => {
                                    // setEmailSearchData([]);
                                    clearTimeout(timer);
                                    if (text.length >= 1) {
                                        setLoadingSearchData(true);
                                        timer = setTimeout(() => {
                                            handleSearch(text, "email").then((r) => {
                                            });
                                        }, 1000);
                                    } else {
                                        setLoadingSearchData(false);
                                    }
                                }}
                                style={multiselectDropdownStyle}
                            />
                        </Col>
                        {/*{registrationFeilds?.includes("cgpa") && !checkProjectType() && (*/}
                        {/*)}*/}
                        {filters?.includes("degree") && (
                            <Col>
                                <Multiselect
                                    className="form-control-alternative filters-sub"
                                    ref={searchByDegree}
                                    // showArrow={true}
                                    hidePlaceholder={true}
                                    displayValue="value"
                                    selectionLimit={1}
                                    placeholder="Search by Degree"
                                    options={degreeSearchData}
                                    closeIcon="cancel"
                                    loading={loadingSearchData}
                                    onSelect={(list, item) => onSelectDegree(item)}
                                    onRemove={removeSearch}
                                    onSearch={(text) => {
                                        // setEmailSearchData([]);
                                        clearTimeout(timer);
                                        if (text.length >= 1) {
                                            setLoadingSearchData(true);
                                            timer = setTimeout(() => {
                                                handleSearch(text, "degree").then((r) => {
                                                });
                                            }, 1000);
                                        } else {
                                            setLoadingSearchData(false);
                                        }
                                    }}
                                    style={multiselectDropdownStyle}
                                />
                            </Col>
                        )}
                    </Row>
                </div>

                <Row>
                    <Col md={"12"} className="d-flex justify-content-end mb-1">
                        <CsvDownloader
                            className="btn btnColor custom-font "
                            filename="Leaderboard-Data"
                            columns={getDynamicColumnsForCsv(leaderboard)}
                            datas={exportToCSV}
                            text="Download CSV"
                        />
                        {/*<CSVLink data={leaderboardToExport}*/}
                        {/*         className="btn btnColor custom-font"*/}
                        {/*         headers={getDynamicColumnsForCsv(leaderboard)}*/}
                        {/*         filename="Leaderboard-Data">*/}
                        {/*    Download CSV*/}
                        {/*</CSVLink>*/}
                    </Col>
                </Row>
                <Row className="mb-4">
                    <Col>
                        <Card className="shadow">
                            <DataTable
                                columns={[
                                    {
                                        name: "Rank",
                                        center: true,
                                        width: "100px",
                                        selector: (row) => row.rank,
                                    },
                                    { name: "Name", wrap: true, selector: (row) => row.name },
                                    { name: "Email", wrap: true, selector: (row) => row.email },
                                    registrationFeilds?.includes("department") &&
                                    checkProjectType() && {
                                        name: "Dept.",
                                        wrap: true,
                                        selector: (row) => row.department,
                                    },
                                    registrationFeilds?.includes("region") &&
                                    checkProjectType() && {
                                        name: "Region",
                                        wrap: true,
                                        selector: (row) => row.region,
                                    },

                                    // {
                                    //     name: 'Institute',
                                    //     width: '100px',
                                    //     center: true,
                                    //     selector: row => row?.userInfo?.institute
                                    // },
                                    // { name: 'CGPA', width: '80px', center: true, selector: row => row?.userInfo?.cgpa },
                                    // {
                                    //     name: 'Degree',
                                    //     width: '100px',
                                    //     center: true,
                                    //     selector: row => row?.userInfo?.degree
                                    // },
                                    // { name: 'City ', width: '100px', center: true, selector: row => row?.userInfo?.city },
                                    // {
                                    //     name: 'Progress',
                                    //     width: '130px',
                                    //     selector: row => row.currentLevel,
                                    //     cell: row => {
                                    //         return (
                                    //             <>
                                    //                 {row.completed ?
                                    //                     <span>Completed</span> :
                                    //                     <span>In-progress/{row.currentLevel}</span>}
                                    //             </>
                                    //         )
                                    //     }
                                    // },
                                    {
                                        name: "Completed",
                                        center: true,
                                        minWidth: "2%",
                                        selector: (row) => row.completedOnce,
                                        cell: (row) => {
                                            return (
                                                <div className="text-center">
                                                    {row.completedOnce ? (
                                                        <div>
                                                            <i className="fas fa-check text-success" />{" "}
                                                            <span className="mx-1">&#9679;</span>{" "}
                                                            {numeral(row.lastCompletedScore).format("0,0")}
                                                        </div>
                                                    ) : (
                                                        <i className="fas fa-times text-danger" />
                                                    )}
                                                </div>
                                            );
                                        },
                                    },
                                    !checkProjectType() && {
                                        name: "Behaviour",
                                        minWidth: "10%",
                                        center: true,
                                        selector: (row) =>
                                            numeral(row.behaviourScore).format("0,0"),
                                    },

                                    !checkProjectType() && {
                                        name: "Aptitude",
                                        minWidth: "10%",
                                        center: true,
                                        selector: (row) => numeral(row.aptitudeScore).format("0,0"),
                                    },
                                    !checkProjectType() && {
                                        name: "Cognitive",
                                        minWidth: "10%",
                                        center: true,
                                        selector: (row) =>
                                            numeral(row.cognitiveScore).format("0,0"),
                                    },
                                    {
                                        name: !checkProjectType() ? "Total Score" : "Score",
                                        minWidth: "10%",
                                        center: true,
                                        selector: (row) => numeral(row.currentScore).format("0,0"),
                                    },

                                    // {
                                    //     name: 'Tries',
                                    //     center: true,
                                    //     width: '100px',
                                    //     selector: row => row.attempts,
                                    //     format: row => numeral(row.attempts).format('0,0')
                                    // },
                                    {
                                        name: "Last Updated",
                                        wrap: true,
                                        minWidth: "10%",
                                        selector: (row) => row.lastUpdated,
                                        format: (row) =>
                                            moment(row.lastUpdated).format("DD/MMM/YY, HH:MM"),
                                    },

                                    checkProjectType() && {
                                        name: "Achievements",
                                        width: "180px",
                                        selector: (row) => row.achievements,
                                        format: (row) => {
                                            return (
                                                <div className="d-flex justify-content-start align-items-center">
                                                    {Object.keys(row.achievements).map(
                                                        (achievementName, index) => (
                                                            // funFact.achievements[achievementName]
                                                            <>
                                                                {row.achievements[achievementName] > 0 && (
                                                                    <div
                                                                        className="badge-item mr-2"
                                                                        key={`leaderboard_${achievementName}`}
                                                                    >
                                                                        <span className="counter-badge">
                                                                            {row.achievements[achievementName]}
                                                                        </span>
                                                                        <img
                                                                            className="mr-2"
                                                                            alt="..."
                                                                            id={`achievementBadge_${achievementName}_${row.rank}`}
                                                                            src={getAchievementBadge(achievementName)}
                                                                            style={{
                                                                                height: "30px",
                                                                                width: "auto",
                                                                            }}
                                                                        />
                                                                        <Tooltip
                                                                            placement="top"
                                                                            isOpen={
                                                                                tooltipOpen ===
                                                                                `${achievementName}_${row.rank}`
                                                                            }
                                                                            target={`achievementBadge_${achievementName}_${row.rank}`}
                                                                            toggle={() =>
                                                                                setTooltipOpen(
                                                                                    tooltipOpen ===
                                                                                        `${achievementName}_${row.rank}`
                                                                                        ? null
                                                                                        : `${achievementName}_${row.rank}`
                                                                                )
                                                                            }
                                                                        >
                                                                            {_.startCase(achievementName)}
                                                                        </Tooltip>
                                                                    </div>
                                                                )}
                                                            </>
                                                        )
                                                    )}
                                                </div>
                                            );
                                        },
                                    },
                                ].filter(Boolean)}
                                data={activeLeaderboard}
                                progressPending={loadingLeaderboard}
                                pagination
                                paginationTotalRows={activeUserCount}
                                paginationServer={true}
                                responsive
                                persistTableHead
                                highlightOnHover
                                paginationRowsPerPageOptions={[10]}
                                onChangePage={(page, totalRows) => {
                                    setCurrentPage(page);
                                }}
                                onChangeRowsPerPage={(currentRowsPerPage, currentPage) => {
                                    setRowsPerPage(currentRowsPerPage);
                                }}
                                currentPage={currentPage}
                            />
                        </Card>
                    </Col>
                </Row>

                {checkProjectType() && (
                    <>
                        <Row className="mb-4">
                            <Col>
                                <h1 className="mb-4 custom-font letterSpacing">Fun Facts</h1>
                                <Card className="shadow">
                                    <DataTable
                                        columns={[
                                            {
                                                name: "",
                                                width: "5%",
                                                selector: (row) => "",
                                                cell: (row, index) => {
                                                    return (
                                                        <img
                                                            className="mr-3"
                                                            alt="..."
                                                            src={getPositionBadge(index + 1)}
                                                            style={{ height: "30px", width: "auto" }}
                                                        />
                                                    );
                                                },
                                            },
                                            { name: "Name", selector: (row) => row.name },
                                            { name: "Email", selector: (row) => row.email },
                                            {
                                                name: "Achievements",
                                                selector: (row) => row.achievements,
                                                cell: (row) => {
                                                    return Object.keys(row.achievements).map(
                                                        (achievementName, index) => (
                                                            <>
                                                                {row.achievements[achievementName] > 0 && (
                                                                    <div
                                                                        className="badge-item mr-2"
                                                                        key={`leaderboard_${achievementName}`}
                                                                    >
                                                                        <span className="counter-badge">
                                                                            {row.achievements[achievementName]}
                                                                        </span>
                                                                        <img
                                                                            className="mr-2"
                                                                            alt="..."
                                                                            id={`achievementBadge_${achievementName}_${index}_ff`}
                                                                            src={getAchievementBadge(achievementName)}
                                                                            style={{
                                                                                height: "30px",
                                                                                width: "auto",
                                                                            }}
                                                                        />
                                                                        <Tooltip
                                                                            placement="top"
                                                                            isOpen={
                                                                                tooltipOpen ===
                                                                                `${achievementName}_${index}_ff`
                                                                            }
                                                                            target={`achievementBadge_${achievementName}_${index}_ff`}
                                                                            toggle={() =>
                                                                                setTooltipOpen(
                                                                                    tooltipOpen ===
                                                                                        `${achievementName}_${index}_ff`
                                                                                        ? null
                                                                                        : `${achievementName}_${index}_ff`
                                                                                )
                                                                            }
                                                                        >
                                                                            {_.startCase(achievementName)}
                                                                        </Tooltip>
                                                                    </div>
                                                                )}
                                                            </>
                                                        )
                                                    );
                                                },
                                            },
                                        ]}
                                        data={funFacts}
                                        progressPending={loadingFunFacts}
                                        responsive
                                        highlightOnHover
                                    />
                                </Card>
                            </Col>
                        </Row>
                    </>
                )}
            </Container>
        </>
    );
};

export default Leaderboard;
